// deno-lint-ignore-file no-unused-vars
import { h, Fragment } from '../jsx-runtime.ts';
import type { Tag, TagAttribute } from '../types.ts';
import { TagsAPI } from '../api.ts';
import { showToast } from './tmk-toast.tsx';

/* ==========================================================================
   Emoji database & helpers (moved from tags-manager.js)
   ========================================================================== */

/* Searchable emoji database: [emoji, ...keywords] */
const EMOJI_DB: string[][] = [
  // — Popularne —
  ['⭐','gwiazda','star','ulubione','fav'],['✅','ok','done','zrobione','gotowe','check'],['❌','nie','no','usun','delete','blad'],['🔥','ogien','fire','hot','pilne','urgent'],['💡','pomysl','idea','lampa','light'],['🎯','cel','goal','target','focus'],['📌','pin','przypinka','wazne'],['📋','lista','clipboard','plan'],['💰','pieniadze','money','budzet','kasa'],['🏆','puchar','trophy','nagroda','win'],['🚀','rakieta','rocket','start','launch'],['💎','diament','diamond','premium','vip'],['🎁','prezent','gift','niespodzianka'],['📝','notatka','note','memo','zapisz'],['🔧','klucz','wrench','naprawa','fix','tool'],['❤️','serce','heart','love'],['👍','super','ok','dobrze','thumb'],['👎','zle','bad','nie'],['⚡','blyskawica','flash','szybko','fast'],['✨','blask','sparkle','nowe','new','magia'],['🔔','dzwonek','bell','alert','powiadomienie'],['📊','wykres','chart','statystyki','stats'],['🏷️','etykieta','tag','label'],['🎉','impreza','party','celebration','sukces'],['💬','komentarz','chat','message','wiadomosc'],['🧠','mozg','brain','myslenie','think','ai'],['🎨','paleta','art','design','sztuka'],['🛡️','tarcza','shield','bezpieczenstwo','security'],['⏰','budzik','alarm','czas','time'],['📱','telefon','phone','mobile','app'],['🌟','gwiazdka','shine','wyroznienie'],['💪','sila','strong','power','muscle'],['🤝','umowa','deal','handshake','wspolpraca'],['📣','megafon','announce','ogloszenie'],['🔍','szukaj','search','lupa','find'],['🗑️','kosz','trash','usun','delete'],['📎','spinacz','clip','attach'],['🔗','link','polaczenie','url'],['⏳','klepsydra','hourglass','czekam','wait'],['🔒','zamek','lock','prywatne','private'],['🔑','klucz','key','haslo','password'],['⚙️','ustawienia','settings','gear','config'],['📤','wyslij','send','upload','eksport'],['📥','pobierz','download','import'],['🗓️','kalendarz','calendar','termin'],['💻','laptop','komputer','computer','code','dev'],['📞','telefon','phone','call','dzwon'],['📧','email','mail','poczta'],
  // — Praca & Biuro —
  ['💼','praca','work','business','teczka'],['📁','folder','katalog','directory'],['📂','folder','otwarty','open'],['📈','wzrost','growth','up','zysk'],['📉','spadek','decline','down','strata'],['🗂️','kartoteka','index','plik'],['✏️','olowek','pencil','edytuj','edit'],['🖊️','dlugopis','pen','pisz'],['📐','katownik','ruler','miara'],['📏','linijka','ruler','measure'],['🗃️','szafka','cabinet','archiwum'],['🖥️','monitor','desktop','ekran','screen'],['⌨️','klawiatura','keyboard','pisanie'],['🖨️','drukarka','printer','druk','print'],['📮','skrzynka','mailbox','poczta'],['✉️','list','letter','koperta','envelope'],['🏢','biuro','office','budynek','building'],['👔','krawat','tie','formal','biznes'],['🗒️','notatnik','notepad','notes'],['📑','zakladka','bookmark','dokument'],['🗳️','urna','vote','glosowanie','ballot'],['💳','karta','card','platnosc','payment'],['🧮','liczydlo','abacus','kalkulacja','calc'],['📡','antena','satellite','sygnal','signal'],['🏛️','urzad','government','instytucja'],['📜','zwoj','scroll','dokument','regulamin'],['📄','dokument','document','strona','page'],['🧾','paragon','receipt','faktura','invoice'],['🖇️','spinacze','paperclip','zalacznik'],['🗄️','szafa','filing','archiwum'],['📇','wizytowka','rolodex','kontakt'],['🪪','dowod','id','identyfikator'],['📃','certyfikat','certificate','zaswiadczenie'],
  // — Dom & Narzędzia —
  ['🏠','dom','home','house'],['🏡','domek','cottage','ogrod'],['🛋️','sofa','couch','kanapa'],['🛏️','lozko','bed','sypialnia'],['🪑','krzeslo','chair','siedzenie'],['🚪','drzwi','door','wejscie'],['🧹','miotla','broom','sprzatanie','clean'],['🧺','kosz','basket','pranie','laundry'],['🍽️','talerz','plate','jedzenie','dinner'],['☕','kawa','coffee','przerwa','break'],['🍵','herbata','tea'],['🔌','kontakt','plug','zasilanie','power'],['🪴','roslina','plant','kwiat'],['📺','telewizor','tv','ogladanie','watch'],['🎮','gra','game','pad','gaming'],['🛁','wanna','bath','kapiel'],['🧸','mis','teddy','zabawka','toy'],['🕯️','swieca','candle','swiatlo'],['🪞','lustro','mirror'],['🧴','krem','lotion','kosmetyk'],['🧽','gabka','sponge','mycie'],['🪣','wiadro','bucket'],['🏗️','budowa','construction','remont'],['🔨','mlotek','hammer','budowa'],['🪛','srubokret','screwdriver'],['🪚','pila','saw','ciecie'],['🔩','sruba','bolt','nut'],['🧰','skrzynka','toolbox','narzedzia'],['🪜','drabina','ladder'],['🛠️','narzedzia','tools','naprawa','repair'],['🧲','magnes','magnet'],['🪠','przepychacz','plunger'],['🧯','gasnica','extinguisher','bezpieczenstwo'],['🔦','latarka','flashlight','torch'],['🪤','pulapka','trap'],
  // — Transport & Podróże —
  ['🚗','auto','car','samochod','jazda'],['🚕','taxi','taksowka'],['🚌','autobus','bus'],['🚇','metro','subway','kolej'],['🚲','rower','bike','bicycle'],['✈️','samolot','plane','flight','lot'],['🚂','pociag','train','kolej'],['⛽','paliwo','fuel','benzyna','gas'],['🗺️','mapa','map','nawigacja'],['🛒','koszyk','cart','zakupy','shopping'],['📦','paczka','package','dostawa','delivery'],['🚁','helikopter','helicopter'],['🛵','skuter','scooter','motor'],['🚢','statek','ship','lodz'],['🛸','ufo','statek','kosmiczny'],['🚐','van','bus','minibus'],['🚎','trolejbus','trolley'],['🚤','motorowka','speedboat','lodz'],['⛵','zaglowka','sailboat','sailing'],['🗼','wieza','tower','landmark'],['🌉','most','bridge'],['🏖️','plaza','beach','wakacje','vacation'],['🗻','gora','mountain','wycieczka'],['🏕️','kemping','camping','namiot','tent'],['🏨','hotel','nocleg','accommodation'],['🧳','walizka','luggage','podróz','travel'],['🛤️','tory','tracks','droga'],['🚏','przystanek','bus stop','stacja'],['⚓','kotwica','anchor','port'],['🚦','sygnalizacja','traffic','swiatla'],
  // — Ludzie & Emocje —
  ['👤','osoba','person','user','uzytkownik'],['👥','ludzie','people','grupa','group','team'],['👨‍💻','programista','developer','coder','dev'],['👩‍💻','programistka','developer','coder','dev'],['👨‍🎓','student','absolwent','graduate'],['👩‍🎓','studentka','absolwentka','graduate'],['👨‍🏫','nauczyciel','teacher','prof'],['👩‍🏫','nauczycielka','teacher','prof'],['👨‍⚕️','lekarz','doctor','med'],['👩‍⚕️','lekarka','doctor','med'],['👨‍🍳','kucharz','cook','chef'],['👩‍🍳','kucharka','cook','chef'],['👷','budowlaniec','worker','construction'],['🧑‍🔧','mechanik','mechanic','serwis'],['🧑‍🎨','artysta','artist','art'],['🧑‍🚀','astronauta','astronaut','kosmos'],['🦸','superbohater','hero','super'],['🦹','zloczyn','villain'],['🧙','czarodziej','wizard','magia','magic'],['🤖','robot','bot','ai','automat'],['👶','dziecko','baby','niemowle'],['🧒','dziecko','child','kid'],['👧','dziewczyna','girl'],['🧑','osoba','person','dorosly'],['👴','dziadek','grandpa','senior'],['👵','babcia','grandma','senior'],['😀','usmiech','smile','szczesliwy','happy'],['😍','zachwyt','love','zakochany'],['🤔','myslenie','thinking','hmm'],['😱','szok','shock','wow','strach'],['😴','spanie','sleeping','zmeczony','tired'],['😎','cool','fajny','okulary'],['🥳','impreza','party','celebration'],['😡','zlosc','angry','mad'],['😢','smutek','sad','placz','cry'],['🤗','uscisk','hug','przytulenie'],['🤫','cicho','secret','quiet','shh'],['🤓','nerd','geek','kujon'],['👻','duch','ghost','halloween'],['🎃','dynia','pumpkin','halloween'],['🎅','mikolaj','santa','christmas','swieta'],
  // — Jedzenie & Napoje —
  ['🍎','jablko','apple','owoc','fruit'],['🍊','pomarancza','orange','owoc'],['🍋','cytryna','lemon'],['🍌','banan','banana'],['🍕','pizza'],['🍔','burger','hamburger'],['🍣','sushi','japonskie'],['🥗','salatka','salad','zdrowe','healthy'],['🍰','tort','cake','ciasto'],['🍩','donut','paczek','slodkie'],['🥤','napoj','drink','sok','juice'],['🍺','piwo','beer'],['🍇','winogrono','grape'],['🍓','truskawka','strawberry'],['🥑','awokado','avocado'],['🌽','kukurydza','corn'],['🥕','marchewka','carrot'],['🥦','brokul','broccoli','zdrowe'],['🍗','kurczak','chicken','mieso'],['🥩','stek','steak','mieso','meat'],['🧀','ser','cheese'],['🥚','jajko','egg'],['🍞','chleb','bread'],['🥐','croissant','rogalik'],['🥯','bajgiel','bagel'],['🍜','zupa','soup','ramen','noodle'],['🍱','bento','lunch','obiad'],['🍙','onigiri','ryz','rice'],['🧁','babeczka','cupcake','slodkie'],['🍫','czekolada','chocolate'],['🍪','ciastko','cookie'],['🍿','popcorn','kino','movie'],['🥂','szampan','champagne','toast'],['🍷','wino','wine'],['🧃','sok','juice','box'],['🥪','kanapka','sandwich'],['🌮','taco','meksyk'],['🌯','burrito','wrap'],['🥘','gulasz','stew','garnek','pot'],['🍝','makaron','pasta','spaghetti'],['🧇','gofr','waffle'],['🥞','nalesnik','pancake'],['🍦','lody','icecream','deser'],['🧈','maslo','butter'],
  // — Sport & Aktywność —
  ['⚽','pilka','football','soccer'],['🏀','koszykowka','basketball'],['🎾','tenis','tennis'],['🏋️','silownia','gym','fitness','ciezary'],['🧘','joga','yoga','medytacja','relax'],['🚴','rower','cycling','kolarstwo'],['🏃','bieganie','running','jogging'],['🏊','plywanie','swimming'],['🏅','medal','award','nagroda'],['🥇','zloty','gold','pierwszy','1st'],['🥈','srebrny','silver','drugi','2nd'],['🥉','brazowy','bronze','trzeci','3rd'],['🎖️','odznaka','medal','badge'],['🏆','puchar','trophy','win','zwyciestwo'],['⚾','baseball'],['🏈','futbol','football','american'],['🏐','siatkowka','volleyball'],['🏒','hokej','hockey'],['🥊','boks','boxing','walka','fight'],['🤸','akrobatyka','acrobatics','gimnastyka'],['🤾','pilka reczna','handball'],['🧗','wspinaczka','climbing','gory'],['🏄','surfing','surf','fale'],['🎿','narty','skiing'],['⛷️','narciarz','skier'],['🎣','wedkarstwo','fishing','ryba'],['🏇','jazda konna','horse','kon'],['🎳','bowling','kregielnia'],['🤹','zonglerka','juggling'],['🥋','karate','sztuki walki','martial'],['⛳','golf'],['🏓','ping pong','tenis stolowy'],['🏸','badminton'],['🥅','bramka','goal','net'],
  // — Nauka & Edukacja —
  ['📚','ksiazki','books','nauka','study','biblioteka'],['🔬','mikroskop','microscope','badanie','research'],['🔭','teleskop','telescope','kosmos'],['🧪','probowka','test','eksperyment','experiment'],['🧬','dna','genetyka','bio'],['🧫','petri','biologia','biology'],['💊','tabletka','pill','lek','medicine'],['🩺','stetoskop','doctor','lekarz','zdrowie','health'],['🩻','rtg','xray','przeswietlenie'],['📖','ksiazka','book','czytanie','reading'],['📕','ksiazka','book','czerwona'],['📗','ksiazka','book','zielona'],['📘','ksiazka','book','niebieska'],['📙','ksiazka','book','pomaranczowa'],['🎓','absolwent','graduate','dyplom','cap'],['✒️','pioro','quill','pisanie'],['🖋️','pioro','fountain pen'],['📰','gazeta','newspaper','wiadomosci','news'],['🏫','szkola','school','edukacja','education'],['⚗️','alchemia','alchemy','chemia','chemistry'],['🔮','kula','crystal ball','magia','wrozba'],['🧑‍🔬','naukowiec','scientist','badacz'],['🧑‍🏫','wykladowca','lecturer','edukator'],['🧮','abakus','abacus','matematyka','math'],['📐','katownik','protractor','geometria'],['🌡️','termometr','thermometer','temperatura'],['⚛️','atom','physics','fizyka','nauka'],['🧲','magnes','magnet','fizyka'],
  // — Muzyka & Rozrywka —
  ['🎵','muzyka','music','nuta','note'],['🎶','nuty','notes','melody','melodia'],['🎸','gitara','guitar','rock'],['🎹','pianino','piano','keyboard','klawisze'],['🎺','trabka','trumpet','jazz'],['🎻','skrzypce','violin','orkiestra'],['🥁','bebny','drums','perkusja'],['🎤','mikrofon','microphone','karaoke','spiew'],['🎧','sluchawki','headphones','muzyka'],['🎼','partytura','score','muzyka'],['🎷','saksofon','saxophone','jazz'],['🪕','banjo','folk'],['🪗','akordeon','accordion'],['📻','radio','fm','stacja'],['🎙️','mikrofon','mic','podcast','nagranie'],['🔊','glosnik','speaker','glosno','loud'],['🔉','glosnik','speaker','ciszej'],['🔈','glosnik','speaker','cicho'],['🔇','wyciszenie','mute','cisza','silence'],['🎬','kino','movie','film','klaps','action'],['🎭','teatr','theater','dramat','drama','maski'],['🎪','cyrk','circus','show'],['🎰','automat','slot','jackpot','kasyno'],['🎲','kostka','dice','gra','game','losowy','random'],['🎯','dart','target','cel'],['🧩','puzzle','ukladanka','zagadka'],['🎮','gra','game','gaming','pad'],['🕹️','joystick','retro','arcade','gra'],['♟️','szachy','chess','strategia'],['🎰','slot','jackpot','losowanie'],['📸','zdjecie','photo','aparat','camera'],['📷','aparat','camera','fotografia'],['🎥','kamera','video','film','nagrywanie'],['📹','kamera','camcorder','video'],
  // — Natura & Zwierzęta —
  ['🌳','drzewo','tree','las','forest'],['🌿','liscie','leaves','ziolo','herb','natura','nature'],['🌸','kwiat','blossom','wiosna','spring'],['🌊','fala','wave','morze','ocean','sea'],['🏔️','gora','mountain','szczyt','peak'],['☀️','slonce','sun','pogoda','lato','summer'],['🌧️','deszcz','rain','pogoda'],['❄️','snieg','snow','zima','winter','mróz'],['🌈','tecza','rainbow'],['🔥','ogien','fire','plomien','flame'],['💧','kropla','drop','woda','water'],['🌺','kwiat','flower','hibiskus'],['🌻','slonecznik','sunflower'],['🌹','roza','rose','romantyczny'],['🌷','tulipan','tulip'],['🌱','kiełek','seedling','wzrost','growth','nowy'],['🍀','koniczyna','clover','szczescie','luck'],['🍂','liscie','leaves','jesien','autumn'],['🍁','klon','maple','jesien'],['🌾','pszenica','wheat','zboze','pole'],['🐝','pszczola','bee','miod','honey'],['🦋','motyl','butterfly'],['🐦','ptak','bird'],['🐾','lapa','paw','zwierze','pet'],['🐶','pies','dog','szczeniak','puppy'],['🐱','kot','cat','kotek','kitty'],['🐟','ryba','fish'],['🦊','lis','fox'],['🦁','lew','lion','krol'],['🐸','zaba','frog'],['🐢','zolw','turtle','powoli','slow'],['🦉','sowa','owl','madrosc','wisdom'],['🌙','ksiezyc','moon','noc','night'],['🌤️','slonecznie','sunny','pogoda'],['⛈️','burza','storm','grzmot','thunder'],['🌪️','tornado','huragan'],['🌫️','mgla','fog'],['🐻','niedzwiedz','bear'],['🐼','panda'],['🐨','koala'],['🦄','jednorozec','unicorn','magia'],['🐬','delfin','dolphin','morze'],['🦈','rekin','shark'],['🐍','waz','snake'],['🦅','orzel','eagle','ptak'],['🦜','papuga','parrot'],['🐙','osmiornica','octopus'],['🌵','kaktus','cactus','pustynia','desert'],['🍄','grzyb','mushroom'],['🪻','lawenda','lavender'],['🪷','lotos','lotus'],['🐛','gasienica','bug','robak','insect'],['🐜','mrowka','ant'],['🦗','konik polny','cricket','owad'],['🪲','zuk','beetle'],
  // — Symbole & Kształty —
  ['⚠️','uwaga','warning','ostrzezenie','alert'],['🚫','zakaz','ban','forbidden','no'],['⛔','stop','zakaz','prohibited'],['🔴','czerwony','red','circle'],['🟠','pomaranczowy','orange','circle'],['🟡','zolty','yellow','circle'],['🟢','zielony','green','circle'],['🔵','niebieski','blue','circle'],['🟣','fioletowy','purple','circle'],['⚪','bialy','white','circle'],['⚫','czarny','black','circle'],['🟤','brazowy','brown','circle'],['♻️','recykling','recycle','eco','ekologia'],['❤️','serce','heart','czerwone','love'],['💜','serce','heart','fioletowe'],['💙','serce','heart','niebieskie'],['💚','serce','heart','zielone'],['💛','serce','heart','zolte'],['🧡','serce','heart','pomaranczowe'],['🤎','serce','heart','brazowe'],['🖤','serce','heart','czarne'],['🤍','serce','heart','biale'],['💔','serce','heart','zlamane','broken'],['❣️','serce','heart','wykrzyknik'],['💕','serca','hearts','dwa'],['💞','serca','hearts','obracane'],['♾️','nieskonczonosc','infinity','forever'],['🔱','trójząb','trident'],['⚜️','lilia','fleur','herb'],['🏁','meta','finish','flaga','flag'],['🚩','flaga','flag','czerwona'],['🏴','flaga','flag','czarna'],['🏳️','flaga','flag','biala'],['♠️','pik','spade','karty'],['♥️','kier','heart','karty'],['♦️','karo','diamond','karty'],['♣️','trefl','club','karty'],['🔶','romb','diamond','pomaranczowy'],['🔷','romb','diamond','niebieski'],['🔸','romb','diamond','maly','pomaranczowy'],['🔹','romb','diamond','maly','niebieski'],['▪️','kwadrat','square','czarny','maly'],['▫️','kwadrat','square','bialy','maly'],['◾','kwadrat','square','czarny'],['◽','kwadrat','square','bialy'],['⬛','kwadrat','square','czarny','duzy'],['⬜','kwadrat','square','bialy','duzy'],['✳️','gwiazdka','asterisk','zielona'],['✴️','gwiazdka','star','pomaranczowa'],['🔲','przycisk','button','czarny'],['🔳','przycisk','button','bialy'],['⭕','kolko','circle','ring'],['➕','plus','dodaj','add'],['➖','minus','odejmij','subtract'],['➗','dzielenie','divide'],['✖️','mnozenie','multiply','x'],['❓','pytanie','question','help'],['❗','wykrzyknik','exclamation','wazne','important'],['💤','sen','sleep','zzz'],['♿','niepelnosprawnosc','disability','access'],['🅿️','parking','park'],['🆔','id','identyfikator','identity'],['🆕','nowy','new'],['🆗','ok'],['🔜','wkrotce','soon'],['🆘','sos','pomoc','help','emergency'],['🔄','odswiez','refresh','reload','powtorz'],['↩️','cofnij','undo','wstecz','back'],['↪️','powtorz','redo','dalej','forward'],['⬆️','gora','up','arrow'],['⬇️','dol','down','arrow'],['⬅️','lewo','left','arrow'],['➡️','prawo','right','arrow'],
  // — Flagi & Kraje —
  ['🇵🇱','polska','poland','pl'],['🇺🇸','usa','ameryka','america','us'],['🇬🇧','uk','anglia','england','british'],['🇩🇪','niemcy','germany','de'],['🇫🇷','francja','france','fr'],['🇪🇸','hiszpania','spain','es'],['🇮🇹','wlochy','italy','it'],['🇯🇵','japonia','japan','jp'],['🇨🇳','chiny','china','cn'],['🇧🇷','brazylia','brazil','br'],['🇺🇦','ukraina','ukraine','ua'],['🇪🇺','europa','eu','unia'],
];

const EMOJI_CATEGORIES_ORDER = ['Popularne','Praca','Dom','Transport','Ludzie','Jedzenie','Sport','Nauka','Muzyka','Natura','Symbole','Flagi'];
const CATEGORY_RANGES: Record<string, [number, number]> = {
  'Popularne': [0, 48], 'Praca': [48, 81], 'Dom': [81, 115], 'Transport': [115, 145],
  'Ludzie': [145, 199], 'Jedzenie': [199, 243], 'Sport': [243, 277], 'Nauka': [277, 305],
  'Muzyka': [305, 339], 'Natura': [339, 397], 'Symbole': [397, 467], 'Flagi': [467, 479],
};

function searchEmoji(query: string): string[] {
  if (!query) return [];
  const q = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const results: string[] = [];
  for (const entry of EMOJI_DB) {
    const [emoji, ...keywords] = entry;
    for (const kw of keywords) {
      if (kw.includes(q)) { results.push(emoji); break; }
    }
  }
  return results;
}

function getCategoryEmojis(category: string): string[] {
  const range = CATEGORY_RANGES[category];
  if (!range) return [];
  return EMOJI_DB.slice(range[0], range[1]).map(e => e[0]);
}

/* ==========================================================================
   Tag with task_count from API
   ========================================================================== */

interface TagWithCount extends Tag {
  task_count?: number;
}

/* ==========================================================================
   TmkTagsManager Web Component
   ========================================================================== */

class TmkTagsManager extends HTMLElement {
  private tags: TagWithCount[] = [];
  private onTagsChanged: (() => void) | null = null;

  async render(opts: { onTagsChanged?: () => void } = {}) {
    this.onTagsChanged = opts.onTagsChanged ?? null;
    await this.fetchData();
    this.renderList();
  }

  private async fetchData() {
    try {
      this.tags = await TagsAPI.list() as TagWithCount[];
    } catch (err: unknown) {
      showToast('Nie udało się załadować tagów: ' + (err as Error).message, 'error');
    }
  }

  private async rerender() {
    await this.fetchData();
    this.renderList();
    if (this.onTagsChanged) this.onTagsChanged();
  }

  // ─── Main render ─────────────────────────────────────────────────────

  private renderList() {
    this.innerHTML = '';

    const list = <div className="tags-manager-list" /> as HTMLElement;
    const groups = this.groupByPrefix(this.tags);

    for (const [prefix, tags] of groups) {
      if (prefix !== '__none__') {
        list.appendChild(<div className="tags-group-header">{prefix}</div> as HTMLElement);
      }
      for (const tag of tags) {
        list.appendChild(this.createTagRow(tag));
      }
    }

    list.appendChild(this.createNewTagRow());
    this.appendChild(list);
  }

  // ─── Group by prefix ─────────────────────────────────────────────────

  private groupByPrefix(tags: TagWithCount[]): Map<string, TagWithCount[]> {
    const groups = new Map<string, TagWithCount[]>();
    for (const tag of tags) {
      const slashIdx = tag.name.indexOf('/');
      const prefix = slashIdx > 0 ? tag.name.substring(0, slashIdx) : '__none__';
      if (!groups.has(prefix)) groups.set(prefix, []);
      groups.get(prefix)!.push(tag);
    }
    return groups;
  }

  // ─── Tag row ──────────────────────────────────────────────────────────

  private createTagRow(tag: TagWithCount): HTMLElement {
    const row = <div className="tag-row" data-tag-id={tag.id} /> as HTMLElement;

    // Color dot
    const colorDot = <span className="tag-color-dot" title="Zmień kolor"
      style={{ backgroundColor: tag.color || '#888888' }}
    /> as HTMLElement;
    colorDot.addEventListener('click', (e) => this.editColor(e, colorDot, tag));
    row.appendChild(colorDot);

    // Icon
    const icon = <span className="tag-icon-cell" title="Zmień ikonkę">{tag.icon || '—'}</span> as HTMLElement;
    icon.addEventListener('click', (e) => this.openIconPicker(e, icon, tag));
    row.appendChild(icon);

    // Name
    const name = <span className="tag-name-cell">{tag.name}</span> as HTMLElement;
    name.addEventListener('click', () => this.editName(name, tag));
    row.appendChild(name);

    // Attributes
    const attrs = <span className="tag-attrs-cell" title="Edytuj atrybuty">
      {(tag.attributes?.length ?? 0) > 0 ? tag.attributes!.map(a => a.name).join(', ') : '—'}
    </span> as HTMLElement;
    attrs.addEventListener('click', (e) => this.openAttributesEditor(e, attrs, tag));
    row.appendChild(attrs);

    // Task count
    row.appendChild(<span className="tag-count-cell">{(tag.task_count || 0) + ' zadań'}</span> as HTMLElement);

    // Delete
    const del = <button className="tag-delete-btn" title={
      (tag.task_count ?? 0) > 0
        ? 'Nie można usunąć — ' + tag.task_count + ' zadań używa tego tagu'
        : 'Usuń tag'
    }>{'\u2716'}</button> as HTMLButtonElement;
    if ((tag.task_count ?? 0) > 0) {
      del.disabled = true;
    } else {
      del.addEventListener('click', () => this.confirmDelete(del, tag));
    }
    row.appendChild(del);

    return row;
  }

  // ─── New tag row ──────────────────────────────────────────────────────

  private createNewTagRow(): HTMLElement {
    const row = <div className="tag-row tag-row-new" /> as HTMLElement;
    const input = <input type="text" className="inline-edit-input tag-new-input"
      placeholder="Nowy tag..."
    /> as HTMLInputElement;

    const save = async () => {
      const val = input.value.trim();
      if (!val) return;
      input.value = '';
      try {
        await TagsAPI.create({ name: val, color: '#4A90D9' });
        await this.rerender();
      } catch (err: unknown) {
        showToast('Błąd tworzenia tagu: ' + (err as Error).message, 'error');
      }
    };

    input.addEventListener('keydown', (e: Event) => {
      if ((e as KeyboardEvent).key === 'Enter') { e.preventDefault(); save(); }
    });
    input.addEventListener('blur', save);

    row.appendChild(input);
    return row;
  }

  // ─── Inline editing — Name ────────────────────────────────────────────

  private editName(el: HTMLElement, tag: TagWithCount) {
    if (el.querySelector('input')) return;

    const input = <input type="text" className="inline-edit-input" value={tag.name} /> as HTMLInputElement;
    el.textContent = '';
    el.appendChild(input);
    input.focus();
    input.select();

    const save = async () => {
      const val = input.value.trim();
      if (!val) { el.textContent = tag.name; return; }
      if (val !== tag.name) {
        try {
          await TagsAPI.update(tag.id, { name: val });
          tag.name = val;
        } catch (err: unknown) {
          showToast('Błąd zapisu nazwy: ' + (err as Error).message, 'error');
        }
      }
      el.textContent = tag.name;
    };

    input.addEventListener('blur', save);
    input.addEventListener('keydown', (e: Event) => {
      const ke = e as KeyboardEvent;
      if (ke.key === 'Enter') { e.preventDefault(); input.blur(); }
      if (ke.key === 'Escape') { el.textContent = tag.name; }
    });
  }

  // ─── Inline editing — Color ───────────────────────────────────────────

  private editColor(e: Event, dot: HTMLElement, tag: TagWithCount) {
    e.stopPropagation();
    if ((dot as unknown as { _colorPicker?: HTMLInputElement })._colorPicker) return;

    const input = document.createElement('input');
    input.type = 'color';
    input.value = tag.color || '#888888';
    input.style.cssText = 'position:absolute;width:0;height:0;opacity:0;pointer-events:none;';

    dot.style.position = 'relative';
    dot.appendChild(input);
    (dot as unknown as { _colorPicker: HTMLInputElement })._colorPicker = input;

    input.addEventListener('input', async () => {
      const val = input.value;
      dot.style.backgroundColor = val;
      try {
        await TagsAPI.update(tag.id, { color: val });
        tag.color = val;
        if (this.onTagsChanged) this.onTagsChanged();
      } catch (err: unknown) {
        showToast('Błąd zapisu koloru: ' + (err as Error).message, 'error');
        dot.style.backgroundColor = tag.color || '#888888';
      }
    });

    const cleanup = () => {
      const d = dot as unknown as { _colorPicker?: HTMLInputElement };
      if (d._colorPicker === input) {
        d._colorPicker = undefined;
        if (input.parentNode) input.remove();
      }
    };

    input.addEventListener('change', cleanup);
    input.addEventListener('blur', () => setTimeout(cleanup, 300));
    input.click();
  }

  // ─── Icon picker popup ────────────────────────────────────────────────

  private openIconPicker(e: Event, iconCell: HTMLElement, tag: TagWithCount) {
    e.stopPropagation();
    this.closeAllPopups();

    const rect = iconCell.getBoundingClientRect();
    const popup = <div className="tags-popup icon-picker-popup" /> as HTMLElement;
    popup.style.cssText = `position:fixed;top:${rect.bottom + 4}px;left:${rect.left}px;z-index:9999;`;
    popup.addEventListener('mousedown', (ev: Event) => ev.stopPropagation());

    // Search
    const searchInput = <input type="text" className="icon-picker-search-input"
      placeholder="Szukaj emoji..."
    /> as HTMLInputElement;
    const searchWrap = <div className="icon-picker-search" /> as HTMLElement;
    searchWrap.appendChild(searchInput);

    // Tabs + Grid
    const tabBar = <div className="icon-picker-tabs" /> as HTMLElement;
    const grid = <div className="icon-picker-grid" /> as HTMLElement;

    let activeCategory = EMOJI_CATEGORIES_ORDER[0];
    let searchMode = false;

    const closePopup = () => {
      if (popup.parentNode) popup.remove();
      document.removeEventListener('mousedown', outsideHandler);
    };

    const selectEmoji = async (emoji: string) => {
      try {
        await TagsAPI.update(tag.id, { icon: emoji });
        tag.icon = emoji;
        iconCell.textContent = emoji;
        if (this.onTagsChanged) this.onTagsChanged();
      } catch (err: unknown) {
        showToast('Błąd zapisu ikonki: ' + (err as Error).message, 'error');
      }
      closePopup();
    };

    const renderEmojis = (emojis: string[]) => {
      grid.innerHTML = '';
      if (emojis.length === 0) {
        grid.appendChild(<div className="icon-picker-empty">Brak wyników</div> as HTMLElement);
        return;
      }
      for (const emoji of emojis) {
        const btn = <button className="icon-picker-btn">{emoji}</button> as HTMLElement;
        btn.addEventListener('click', () => selectEmoji(emoji));
        grid.appendChild(btn);
      }
    };

    const renderTabs = () => {
      tabBar.innerHTML = '';
      for (const cat of EMOJI_CATEGORIES_ORDER) {
        const tab = <button className={'icon-picker-tab' + (!searchMode && cat === activeCategory ? ' active' : '')}>
          {cat}
        </button> as HTMLElement;
        tab.addEventListener('click', () => {
          searchMode = false;
          searchInput.value = '';
          activeCategory = cat;
          renderTabs();
          renderEmojis(getCategoryEmojis(cat));
        });
        tabBar.appendChild(tab);
      }
    };

    let searchTimer: number | null = null;
    searchInput.addEventListener('input', () => {
      if (searchTimer) clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => {
        const q = searchInput.value.trim();
        if (q) {
          searchMode = true;
          renderTabs();
          renderEmojis(searchEmoji(q));
        } else {
          searchMode = false;
          renderTabs();
          renderEmojis(getCategoryEmojis(activeCategory));
        }
      }, 120);
    });

    // Clear icon button
    const clearBtn = <button className="icon-picker-clear">{'\u2715 Wyczyść'}</button> as HTMLElement;
    clearBtn.addEventListener('click', async () => {
      try {
        await TagsAPI.update(tag.id, { icon: null });
        tag.icon = null;
        iconCell.textContent = '—';
        if (this.onTagsChanged) this.onTagsChanged();
      } catch (err: unknown) {
        showToast('Błąd zapisu ikonki: ' + (err as Error).message, 'error');
      }
      closePopup();
    });

    renderTabs();
    renderEmojis(getCategoryEmojis(activeCategory));

    popup.appendChild(searchWrap);
    popup.appendChild(tabBar);
    popup.appendChild(grid);
    popup.appendChild(clearBtn);

    requestAnimationFrame(() => searchInput.focus());
    document.body.appendChild(popup);
    this.clampPopupToViewport(popup);

    const outsideHandler = (ev: Event) => {
      if (!popup.contains(ev.target as Node)) closePopup();
    };
    requestAnimationFrame(() => document.addEventListener('mousedown', outsideHandler));
  }

  // ─── Attributes editor popup ──────────────────────────────────────────

  private openAttributesEditor(e: Event, attrsCell: HTMLElement, tag: TagWithCount) {
    e.stopPropagation();
    this.closeAllPopups();

    const rect = attrsCell.getBoundingClientRect();
    const attrs: TagAttribute[] = tag.attributes ? [...tag.attributes] : [];

    const popup = <div className="tags-popup attrs-editor-popup" /> as HTMLElement;
    popup.style.cssText = `position:fixed;top:${rect.bottom + 4}px;left:${rect.left}px;z-index:9999;`;
    popup.addEventListener('mousedown', (ev: Event) => ev.stopPropagation());

    popup.appendChild(<div className="attrs-editor-title">Atrybuty</div> as HTMLElement);

    const listEl = <div className="attrs-editor-list" /> as HTMLElement;

    const renderAttrs = () => {
      listEl.innerHTML = '';
      for (let i = 0; i < attrs.length; i++) {
        const attr = attrs[i];
        const row = <div className="attrs-editor-row" /> as HTMLElement;

        const nameInput = <input type="text" className="inline-edit-input"
          value={attr.name || ''} placeholder="Nazwa"
        /> as HTMLInputElement;
        nameInput.addEventListener('blur', () => {
          attr.name = nameInput.value.trim();
          this.saveAttributes(tag, attrs, attrsCell);
        });
        nameInput.addEventListener('keydown', (ev: Event) => {
          if ((ev as KeyboardEvent).key === 'Enter') { ev.preventDefault(); nameInput.blur(); }
        });
        row.appendChild(nameInput);

        const typeSelect = <select className="inline-edit-input" /> as HTMLSelectElement;
        for (const t of ['string', 'number', 'boolean'] as const) {
          const opt = <option value={t}>{t}</option> as HTMLOptionElement;
          if (attr.type === t) opt.selected = true;
          typeSelect.appendChild(opt);
        }
        typeSelect.addEventListener('change', () => {
          attr.type = typeSelect.value as TagAttribute['type'];
          this.saveAttributes(tag, attrs, attrsCell);
        });
        row.appendChild(typeSelect);

        const removeBtn = <button className="attrs-editor-remove">{'\u2715'}</button> as HTMLElement;
        removeBtn.addEventListener('click', () => {
          attrs.splice(i, 1);
          this.saveAttributes(tag, attrs, attrsCell);
          renderAttrs();
        });
        row.appendChild(removeBtn);

        listEl.appendChild(row);
      }
    };

    const addBtn = <button className="attrs-editor-add">+ Dodaj atrybut</button> as HTMLElement;
    addBtn.addEventListener('click', () => {
      attrs.push({ name: '', type: 'string' });
      renderAttrs();
      const inputs = listEl.querySelectorAll('input[type="text"]');
      if (inputs.length > 0) (inputs[inputs.length - 1] as HTMLInputElement).focus();
    });

    renderAttrs();
    popup.appendChild(listEl);
    popup.appendChild(addBtn);

    document.body.appendChild(popup);
    this.clampPopupToViewport(popup);

    const closePopup = () => {
      if (popup.parentNode) popup.remove();
      document.removeEventListener('mousedown', outsideHandler);
    };
    const outsideHandler = (ev: Event) => {
      if (!popup.contains(ev.target as Node)) closePopup();
    };
    requestAnimationFrame(() => document.addEventListener('mousedown', outsideHandler));
  }

  private async saveAttributes(tag: TagWithCount, attrs: TagAttribute[], attrsCell: HTMLElement) {
    const validAttrs = attrs.filter(a => a.name && a.name.trim());
    try {
      await TagsAPI.update(tag.id, { attributes: validAttrs } as Record<string, unknown>);
      tag.attributes = validAttrs;
      attrsCell.textContent = validAttrs.length > 0 ? validAttrs.map(a => a.name).join(', ') : '—';
      if (this.onTagsChanged) this.onTagsChanged();
    } catch (err: unknown) {
      showToast('Błąd zapisu atrybutów: ' + (err as Error).message, 'error');
    }
  }

  // ─── Delete with inline confirmation ──────────────────────────────────

  private confirmDelete(btn: HTMLElement, tag: TagWithCount) {
    if (btn.dataset.confirming) return;
    btn.dataset.confirming = 'true';

    const row = btn.closest('.tag-row')!;
    const confirm = <span className="tag-delete-confirm">Na pewno? </span> as HTMLElement;

    const yesBtn = <button className="tag-confirm-yes" onClick={async (e: Event) => {
      e.stopPropagation();
      try {
        await TagsAPI.delete(tag.id);
        await this.rerender();
      } catch (err: unknown) {
        showToast('Błąd usuwania tagu: ' + (err as Error).message, 'error');
        confirm.remove();
        delete btn.dataset.confirming;
        btn.style.display = '';
      }
    }}>Tak</button> as HTMLElement;

    const noBtn = <button className="tag-confirm-no" onClick={(e: Event) => {
      e.stopPropagation();
      confirm.remove();
      delete btn.dataset.confirming;
      btn.style.display = '';
    }}>Nie</button> as HTMLElement;

    confirm.appendChild(yesBtn);
    confirm.appendChild(noBtn);
    btn.style.display = 'none';
    row.appendChild(confirm);
  }

  // ─── Helpers ──────────────────────────────────────────────────────────

  private closeAllPopups() {
    document.querySelectorAll('.icon-picker-popup, .attrs-editor-popup').forEach(p => p.remove());
  }

  private clampPopupToViewport(popup: HTMLElement) {
    requestAnimationFrame(() => {
      const rect = popup.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        popup.style.left = Math.max(4, window.innerWidth - rect.width - 4) + 'px';
      }
      if (rect.bottom > window.innerHeight) {
        popup.style.top = Math.max(4, window.innerHeight - rect.height - 4) + 'px';
      }
    });
  }
}

customElements.define('tmk-tags-manager', TmkTagsManager);

export { TmkTagsManager };
